/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useMemo, useEffect, lazy ,Suspense  } from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom"
import { StoreContext } from "redux-react-hook"
import { getSearch, toLitePath, storeParams, getLoginPath, isPublicPage } from 'utils/utils'
import { RouterPaths } from 'utils/constant'
import { $login, clearLoginInfo } from 'service/sign'
import { $affSendCode } from 'service/affiliate'
import store from 'store'
import Loading from 'components/loading'
import { SET_LOGGING_IN } from 'store/ActionTypes'
import { createAction } from 'store/ActionTypes'
const ForgetEmail = lazy(() => import('pages/sign/Forget-email'))
const SignInPhone = lazy(() => import("pages/sign/SignIn-phone"))
const SignInQr = lazy(() => import("pages/sign/SingIn-qr"))
const ForgetPhone = lazy(() => import("pages/sign/Forget-phone"))
const Affiliate = lazy(() => import("pages/affiliate/index"))
const SignInEmail = lazy(() => import("pages/sign/SignIn-email"))
const ActivityPage = lazy(() => import("pages/activity/index"))
const AffiliateWithdrawRecords = lazy(() => import("pages/affiliate/WithdrawRecords")) 
const AffiliateAwardRecords = lazy(() => import("pages/affiliate/AwardRecords")) 
const Recharge = lazy(() => import('pages/recharge')) 
const Menu = lazy(() => import('pages/menu/menu')) 
const Thanks = lazy(() => import('./pages/thanks-for-using/index' )) 
const ResetPasswd = lazy(() => import('pages/sign/Reset-password'))
const Shop = lazy(() => import('pages/shop/index'))
const Tv = lazy(() => import('pages/tv/index'))
const Invite = lazy(() => import("pages/invite/index"))
const InviteRecords = lazy(() => import("pages/invite/records/index"))
const InviteShare = lazy(() => import("pages/invite/share/index"))
const Lottery = lazy(() => import("pages/lottery/index"))
const LotteryRecords = lazy(() => import("pages/lottery/records/index"))
const LotteryRules = lazy(() => import("pages/lottery/rules/index"))

const routes = [
  {
    path: RouterPaths["tv"],
    component: Tv
  },
  {
    path: RouterPaths["signin-email"],
    component: SignInEmail
  },
  {
    path: RouterPaths["signin-email_lite"],
    component: SignInEmail
  },
  {
    path: RouterPaths["forget-email"],
    component: ForgetEmail
  },
  {
    path: RouterPaths["forget-email_lite"],
    component: ForgetEmail
  },
  {
    path: RouterPaths["signin-phone"],
    component: SignInPhone
  },
  {
    path: RouterPaths["signin-phone_lite"],
    component: SignInPhone
  },
  {
    path: RouterPaths["signin-qr"],
    component: SignInQr
  },
  {
    path: RouterPaths["signin-qr_lite"],
    component: SignInQr
  },
  {
    path: RouterPaths["forget-phone"],
    component: ForgetPhone
  },
  {
    path: RouterPaths["forget-phone_lite"],
    component: ForgetPhone
  },
  {
    path: RouterPaths["reset-password"],
    component: ResetPasswd
  },
  {
    path: RouterPaths["reset-password_lite"],
    component: ResetPasswd
  },
  {
    path: RouterPaths.home,
    component: Recharge
  },
  {
    path: RouterPaths.home_lite,
    component: Recharge
  },
  {
    path: RouterPaths.menu,
    component: Menu,
    auth: true,
    parameters: true,
  },
  {
    path: RouterPaths.myAffiliate,
    component: Affiliate,
    auth: true,
  },
  {
    path: RouterPaths.affiliateWithdrawRecords,
    component: AffiliateWithdrawRecords,
    auth: true,
  },
  {
    path: RouterPaths.affiliateAwardRecords,
    component: AffiliateAwardRecords,
    auth: true,
  },
  {
    path: RouterPaths.thanksForUsing,
    component: Thanks,
    auth: true,
  },
  {
    path: RouterPaths.Activity,
    component: ActivityPage,
    // auth: true,
  },
  {
    path: RouterPaths.ActivityLite,
    component: ActivityPage,
    // auth: true,
  },
  {
    path: RouterPaths.shop,
    component: Shop,
  },
  {
    path: RouterPaths.shop_lite,
    component: Shop,
  },
  {
    path: RouterPaths.invite,
    component: Invite,
  },
  {
    path: RouterPaths.inviteRecords,
    component: InviteRecords,
  },
  {
    path: RouterPaths.inviteShare,
    component: InviteShare,
  },
  {
    path: RouterPaths.lottery,
    component: Lottery,
  },
  {
    path: RouterPaths.lotteryRecords,
    component: LotteryRecords,
  },
  {
    path: RouterPaths.lotteryRules,
    component: LotteryRules,
  },
]

const redirectRoutes = [
  {
    path: "/payment/thanks-for-using",
    redirect: RouterPaths.thanksForUsing
  },
  // {
  //   path: "/payment/activity",
  //   redirect: RouterPaths.Activity
  // },
  {
    path: "/payment/signin",
    redirect: RouterPaths["signin-phone"]
  },
  {
    path: "/payment/signup",
    redirect: RouterPaths["signin-phone"]
  },
  // {
  //   path: RouterPaths["signin-phone"],
  //   redirect: RouterPaths["signin-email"]
  // },
  {
    path: '/',
    redirect: toLitePath(RouterPaths.home)
  },
]

const App: React.FC = () => {
  return (
    <StoreContext.Provider value={store}>
      <AppRouter />
    </StoreContext.Provider>
  )
}

const AppRouter: React.FC = () => {
  useEffect(() => {

    const loginToken = getSearch('login-token')
    const redirect = getSearch('redirect')
    const affiliateCode = getSearch('affiliate-code')
    
    storeParams()

    if (loginToken) {
      clearLoginInfo()
      store.dispatch(createAction(SET_LOGGING_IN, true))
      $login(decodeURIComponent(loginToken))
        .then((res) => { 
          store.dispatch(createAction(SET_LOGGING_IN, false))
          if(isPublicPage()) return
          if(res.code===0){
            if (!res.data.phone_num) {
              // setLoginInfo(res.data, res.data.token.access_token)
              sessionStorage.setItem('bandemail',JSON.stringify(res.data))
              clearLoginInfo()
              console.log('当前账号未绑定手机号')
              // history.push(RouterPaths["forget-email"])
              window.location.href = `/payment/signin-email?qridLogin=true${redirect ? '&redirect=' + redirect : ''  }`
            }else{
              if (redirect) {
                window.location.href = redirect
              }
            }
          }else{
            window.location.href = getLoginPath()
          }
          
        })
        .catch(() => {
          store.dispatch(createAction(SET_LOGGING_IN, false))
        })
    }
    if (affiliateCode) {
      $affSendCode(affiliateCode)
    }
  }, [])

  return useMemo(() => (
    <Suspense fallback={<Loading/>}>
      <Router>
        <Switch>
          {
            routes.map(R => {
              if (R.auth) {
                return privateRoute(R)
              }
              return render(R)
            })
          }
          {
            redirectRoutes.map(i => (
              <Redirect key={i.path} from={i.path} to={i.redirect} />
            ))
          }
        </Switch>
      </Router>
    </Suspense>

  ), [])
}

function render(R: any) {
  return (
    <Route
      key={R.path}
      path={R.parameters ? `${R.path}/:id` : R.path}
      exact
      component={R.component}
    />
  )
}

function privateRoute({ component: Component, ...rest }) {
  return (
    <Route
      key={rest.path}
      {...rest}
      path={rest.parameters ? `${rest.path}/:id` : rest.path}
      exact
      render={props => {
        return store.getState().user.logined ? (
          <Component {...props} />
        ) : (
          props.match.url === '/payment/thanks-for-using' ?
            <Component {...props} />
            : <Redirect
              to={{
                pathname: "/"
              }}
            />
        )
      }
      }
    />
  )
}

export default App
